import { render, staticRenderFns } from "./CurveTab.vue?vue&type=template&id=03c9b350&scoped=true"
import script from "./CurveTab.vue?vue&type=script&lang=ts"
export * from "./CurveTab.vue?vue&type=script&lang=ts"
import style0 from "./CurveTab.vue?vue&type=style&index=0&id=03c9b350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9b350",
  null
  
)

export default component.exports